import { useState } from 'react';
let id = 0;
export function useUniqId() {
    return useState(() => `${id++}`)[0];
}
